<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <line
      x1="12.47"
      y1="9.93"
      x2="12.47"
      y2="24"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
    <path
      d="M19.28,13.77c0,3.76-3.05,6.81-6.81,6.81s-6.81-3.05-6.81-6.81S11.02,3.96,12.47,1.97c1.57,2.06,6.81,8.05,6.81,11.81Z"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="1.5"
    />
  </svg>
</template>
